angular.module('picmonicng').component('homeEducatorDataComponent', {
  templateUrl: '/templates/app/components/home-educator-data/home-educator-data.html',
  controller: [
    'UserService',
    'User',
    'LocalStorageService',
    '$filter',
    '$scope',
    'MarketOptionsConfig',
    '$modal',
    'schoolClassResource',
    'Schools',
    'toaster',
    '$stateParams',
    '$http',
    '$cookies',
    function (
      UserService,
      User,
      LocalStorageService,
      $filter,
      $scope,
      MarketOptionsConfig,
      $modal,
      schoolClassResource,
      Schools,
      toaster,
      $stateParams,
      $http,
      $cookies
    ) {
      var ctrl = this;
      var localLocale;
      ctrl.UserService = UserService;

      if (
        !UserService.user.approved_educator ||
        !UserService.user.school.school_id ||
        UserService.user.school.name.indexOf('Other') !== -1
      ) {
        return;
      }

      atlasEvent('pageview', 'educator_home');

      ctrl.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
      ctrl.showStudent = false;
      ctrl.blur = Boolean(
        UserService.user && UserService.user.approved_educator && !UserService.user.institutional_sub
      );
      ctrl.filter = LocalStorageService.getItem('pls_school_class_filter') || 'All Time';
      ctrl.weekStart = LocalStorageService.getItem('edu-week-start') || '1';
      ctrl.by = 'student';
      ctrl.studentBy = 'date';
      ctrl.showClassManagement = 0;
      ctrl.educators = Schools.educators({
        school_id: UserService.user.school.school_id,
      });
      ctrl.allStudents = [];
      ctrl.orderBy = 'user';
      $http.get('/api/v3/educator_data/students').then(function (response) {
        ctrl.allStudents = response.data;
      });

      ctrl.order = function (field) {
        ctrl.orderBy = ctrl.orderBy === field ? '-' + field : field;
      };

      ctrl.showInvite = function (c) {
        $modal.open({
          backdrop: 'static',
          controller: [
            '$scope',
            function ($scope) {
              $scope.class = c;
            },
          ],
          template: '<invite-students school-class="class" close="$dismiss()"></invite-students>',
        });
      };

      ctrl.classes = schoolClassResource.query({
        school_id: UserService.user.school.school_id,
      });
      ctrl.getClassTitle = function (c) {
        return (
          c.name +
          (c.instructors.length
            ? ' - ' +
              c.instructors
                .map(function (a) {
                  return a.last_name;
                })
                .join(',')
            : '') +
          (c.start_date ? ' - ' + c.start_date + ' - ' + c.end_date : '')
        );
      };

      ctrl.classes.$promise.then(function () {
        var classes = $filter('filter')(
          ctrl.classes,
          UserService.user.educator_admin ? {} : { instructors: { id: UserService.user.user_id } }
        );
        if (classes.length) {
          if (LocalStorageService.getItem('pls_school_class_id')) {
            ctrl.class =
              $filter('filter')(classes, {
                school_class_id: LocalStorageService.getItem('pls_school_class_id'),
              })[0] || $filter('orderBy')(classes, 'status')[0];
          } else {
            ctrl.class = $filter('orderBy')(classes, 'status')[0];
          }
        } else {
          ctrl.class = {};
        }

        if (UserService.user.educator_admin) {
          ctrl.classes.push({
            name: 'All Students',
            school_class_id: undefined,
            status: 'Other',
            instructors: [],
          });
          ctrl.classes.push({
            name: 'Students w/ No Class',
            school_class_id: 'none',
            status: 'Other',
            instructors: [],
          });
        }

        ctrl.students = User.queryv3({
          resource: 'student_data',
          by: 'student',
          school_class_id: ctrl.class.school_class_id,
        });

        ctrl.setPeriod(ctrl.filter);
      });

      $scope.$watch(
        function () {
          return ctrl.class;
        },
        function (clas) {
          clas && clas.school_class_id && LocalStorageService.setItem('pls_school_class_id', clas.school_class_id);
        }
      );

      $scope.$watch(
        function () {
          return ctrl.filter;
        },
        function (filter) {
          LocalStorageService.setItem('pls_school_class_filter', filter);
        }
      );

      ctrl.deleteClass = function (c) {
        if (confirm('Are you sure you want to delete this class?')) {
          schoolClassResource.delete({
            school_class_id: c.school_class_id,
            school_id: c.school_id,
          });
          ctrl.classes.splice(ctrl.classes.indexOf(c), 1);
        }
      };

      ctrl.editClass = function (c) {
        $modal.open({
          templateUrl: '/templates/app/components/home-educator-data/create-class.html',
          backdrop: 'static',
          controller: [
            '$scope',
            '$filter',
            'Upload',
            function ($scope, $filter, Upload) {
              $scope.students = ctrl.allStudents;
              $scope.educators = ctrl.educators;
              $scope.added = [];
              $scope.step = 1;
              $scope.class = angular.copy(c);
              $scope.instructors = {};
              $scope.class.instructor_ids = [];
              angular.forEach($scope.class.instructors, function (e) {
                $scope.instructors[e.id] = true;
                $scope.class.instructor_ids.push(e.id);
              });
              $scope.saveClass = function () {
                schoolClassResource.update($scope.class).$promise.then(function (data) {
                  angular.merge(c, data);
                });

                $scope.$close();
              };
              $scope.editStudents = function () {
                $scope.$close();
                ctrl.editStudents(c);
              };
              $scope.showInvite = function () {
                ctrl.showInvite($scope.class);
                $scope.$close();
              };
              $scope.toggleEdu = function (id) {
                var index = $scope.class.instructor_ids.indexOf(id);
                index > -1 ? $scope.class.instructor_ids.splice(index, 1) : $scope.class.instructor_ids.push(id);
              };
            },
          ],
        });
      };

      ctrl.classesFilter = function (c) {
        if (ctrl.class_search) {
          var t = false;
          if (c.name.toLowerCase().indexOf(ctrl.class_search.toLowerCase()) > -1) {
            t = true;
          }
          angular.forEach(c.instructors, function (i) {
            if (
              i.first_name.indexOf(ctrl.class_search) > -1 ||
              i.last_name.indexOf(ctrl.class_search) > -1 ||
              i.email.indexOf(ctrl.class_search) > -1
            ) {
              t = true;
            }
          });
          if (!t) {
            return false;
          }
        }

        if (ctrl.status != 'All' && c.status !== ctrl.status) {
          return false;
        }

        return true;
      };

      ctrl.status = 'Current';

      ctrl.editStudents = function (c) {
        $modal.open({
          templateUrl: '/templates/app/components/home-educator-data/edit-students.html',
          backdrop: 'static',
          controller: [
            '$scope',
            '$filter',
            'Upload',
            function ($scope) {
              $scope.UserService = UserService;
              $scope.class = c;
              $scope.addStudents = function (c) {
                ctrl.addStudents(c);
                $scope.$close();
              };
              $scope.removeStudent = function (student) {
                $scope.class.students.splice($scope.class.students.indexOf(student), 1);
                schoolClassResource.removeStudent({
                  school_id: c.school_id,
                  school_class_id: c.school_class_id,
                  email: student.email,
                });
              };
              $scope.showInvite = function () {
                ctrl.showInvite($scope.class);
                $scope.$close();
              };
            },
          ],
        });
      };

      ctrl.setWeekStart = function () {
        moment.defineLocale('en-edu', {
          week: {
            dow: ctrl.weekStart,
          },
        });
        moment.locale('en');
        localLocale = moment().locale('en-edu');
        LocalStorageService.setItem('edu-week-start', ctrl.weekStart);
      };
      ctrl.setWeekStart();

      ctrl.f = function (a) {
        if (!ctrl.search) {
          return true;
        }
        return (
          a.email.toLowerCase().indexOf(ctrl.search.toLowerCase()) > -1 ||
          a.user.toLowerCase().indexOf(ctrl.search.toLowerCase()) > -1
        );
      };

      ctrl.endDate = moment().endOf('month');
      ctrl.startDate = moment().startOf('month');

      ctrl.changeBy = function (by) {
        ctrl.by = by;
        if (by !== 'student') {
          return;
        }
        ctrl.data = User.queryv3({
          resource: 'student_data',
          by: ctrl.by,
          start: ctrl.start,
          end: ctrl.end,
          school_class_id: ctrl.class.school_class_id,
        });
        ctrl.video_plays = 0;
        ctrl.questions_answered = 0;
        ctrl.questions_correct = 0;
        ctrl.data.$promise.then(function (data) {
          angular.forEach(data, function (row) {
            ctrl.video_plays += row.times_video_played;
            ctrl.questions_correct += parseInt(row.questions_correct);
            ctrl.questions_answered += parseInt(row.questions_answered);
          });
        });

        ctrl.students = User.queryv3({
          resource: 'student_data',
          by: 'student',
          start: ctrl.start,
          end: ctrl.end,
          school_class_id: ctrl.class.school_class_id,
        });
      };

      ctrl.setPeriod = function (change, prev) {
        if (change === 'class' && !ctrl.class) {
          ctrl.createClass();
          ctrl.class = prev;
          return false;
        }
        switch (ctrl.filter) {
          case 'This Week':
            ctrl.end = localLocale.endOf('week').unix();
            ctrl.start = ctrl.end - 7 * 86400;
            break;
          case 'Last Week':
            ctrl.end = localLocale.endOf('week').unix() - 7 * 86400;
            ctrl.start = ctrl.end - 7 * 86400;
            break;
          case 'All Time':
            ctrl.end = null;
            ctrl.start = null;
            break;
          case 'Custom':
            ctrl.end = moment(ctrl.endDate).startOf('day').unix() + 86399;
            ctrl.start = moment(ctrl.startDate).startOf('day').unix();
        }
        ctrl.changeBy(ctrl.by);
      };

      ctrl.getStudent = function (id) {
        angular.element('body').unbind('click', clickHandler);

        ctrl.showStudent = $filter('filter')(ctrl.students, { id: id }, true)[0];
        var weeks = [];
        var stats = [];
        User.queryv3({
          resource: 'student_data',
          by: 'date',
          start: ctrl.start,
          end: ctrl.end,
          id: id,
        }).$promise.then(function (data) {
          angular.forEach(data, function (row) {
            var end = localLocale.endOf('week').unix();
            var week = Math.floor((end - row.start_time) / (86400 * 7));
            if (weeks[week]) {
              weeks[week].push(row);
              row.times_video_played && stats[week].videos.push(row.slug);
              stats[week] = {
                videos: _.uniq(stats[week].videos),
                questions_answered: stats[week].questions_answered + parseInt(row.questions_answered),
                questions_correct:
                  stats[week].questions_correct + parseInt(row.questions_answered || 0) * (row.quiz_accuracy || 0),
                round_count: stats[week].round_count + parseInt(row.round_count || 0),
              };
            } else {
              stats[week] = {
                videos: row.times_video_played ? [row.slug] : [],
                questions_answered: parseInt(row.questions_answered),
                questions_correct: parseInt(row.questions_answered) * row.quiz_accuracy,
                round_count: parseInt(row.round_count),
              };
              weeks[week] = [row];
            }
          });
          ctrl.studentData = weeks;
          ctrl.studentDataStats = stats;
          angular.element('body').bind('click', clickHandler);
        });
        ctrl.getWeekDates = function (week) {
          var end = localLocale.endOf('week').unix();
          return (
            moment.unix(end - (week + 1) * 7 * 86400 + 1).format('M/D') +
            ' - ' +
            moment.unix(end - week * 7 * 86400).format('M/D')
          );
        };

        ctrl.nextStudent = function () {
          ctrl.showStudent =
            ctrl.students[Math.min(ctrl.students.indexOf(ctrl.showStudent) + 1, ctrl.students.length - 1)];
          ctrl.getStudent(ctrl.showStudent.id);
        };

        ctrl.prevStudent = function () {
          ctrl.showStudent = ctrl.students[Math.max(ctrl.students.indexOf(ctrl.showStudent) - 1, 0)];
          ctrl.getStudent(ctrl.showStudent.id);
        };
      };

      function clickHandler(e) {
        if (!angular.element('#student-drawer').has(angular.element(e.target)).length) {
          $scope.$apply(function () {
            ctrl.showStudent = false;
          });
        }
      }

      ctrl.addStudents = function (c) {
        $modal.open({
          templateUrl: '/templates/app/components/home-educator-data/create-class.html',
          backdrop: 'static',
          controller: [
            '$scope',
            '$filter',
            'Upload',
            '$timeout',
            function ($scope, $filter, Upload, $timeout) {
              $scope.UserService = UserService;
              $scope.students = ctrl.allStudents.filter(function (s) {
                return !$filter('filter')(c.students, { user: { id: s.id } }, true).length;
              });
              $scope.educators = ctrl.educators;
              $scope.added = [];
              $scope.class = c;
              $scope.showInvite = function () {
                ctrl.showInvite($scope.class);
                $timeout($scope.$close, 0);
              };
              if ($scope.students.length) {
                $scope.step = 3;
              } else {
                $scope.showInvite();
              }
              $scope.selectedStudents = {};

              $scope.f = function (a) {
                if (!$scope.q) {
                  return true;
                }
                return (
                  a.email.toLowerCase().indexOf($scope.q.toLowerCase()) > -1 ||
                  a.user.toLowerCase().indexOf($scope.q.toLowerCase()) > -1
                );
              };

              $scope.saveRoster = function () {
                $scope.class.student_ids = Object.keys($scope.selectedStudents).filter(function (id) {
                  return $scope.selectedStudents[id];
                });
                $scope.class.$update();
                $scope.$close();
                toaster.success('Roster Saved!');
              };

              $scope.uploadFiles = function (file) {
                if (file) {
                  $scope.loadingImport = true;
                  file.upload = Upload.upload({
                    url:
                      '/api/v3/schools/' +
                      UserService.user.school.school_id +
                      '/classes/' +
                      $scope.class.school_class_id +
                      '/upload',
                    data: { file: file },
                  });

                  file.upload
                    .then(function (response) {
                      angular.merge($scope.class, response.data);
                      $scope.$close();
                      toaster.success('Roster Uploaded Successfully!');
                    })
                    .finally(function () {
                      $scope.loadingImport = false;
                    });
                }
              };
            },
          ],
        });
      };

      ctrl.createClass = function () {
        $modal.open({
          templateUrl: '/templates/app/components/home-educator-data/create-class.html',
          backdrop: 'static',
          controller: [
            '$scope',
            '$filter',
            'Upload',
            function ($scope, $filter, Upload) {
              $scope.UserService = UserService;
              $scope.students = ctrl.allStudents;
              $scope.educators = ctrl.educators || [];
              $scope.added = [];
              $scope.step = 1;
              $scope.class = {
                school_id: UserService.user.school.school_id,
                instructor_ids: [],
              };
              $scope.saveClass = function () {
                $scope.class = schoolClassResource.save($scope.class);
                ctrl.classes.push($scope.class);
                if ($scope.students.length) {
                  $scope.step = 3;
                } else {
                  $scope.showInvite();
                }
              };

              $scope.selectedStudents = {};

              $scope.saveRoster = function () {
                $scope.class.student_ids = Object.keys($scope.selectedStudents).filter(function (id) {
                  return $scope.selectedStudents[id];
                });
                $scope.class.$update();
                $scope.$close();
                toaster.success('Roster Saved!');
              };

              $scope.showInvite = function () {
                ctrl.showInvite($scope.class);
                $scope.saveRoster();
              };

              $scope.toggleEdu = function (id) {
                var index = $scope.class.instructor_ids.indexOf(id);
                index > -1 ? $scope.class.instructor_ids.splice(index, 1) : $scope.class.instructor_ids.push(id);
              };

              $scope.uploadFiles = function (file) {
                if (file) {
                  $scope.loadingImport = true;
                  file.upload = Upload.upload({
                    url:
                      '/api/v3/schools/' +
                      UserService.user.school.school_id +
                      '/classes/' +
                      $scope.class.school_class_id +
                      '/upload',
                    data: { file: file },
                  });

                  file.upload
                    .then(function (response) {
                      angular.merge($scope.class, response.data);
                      $scope.$close();
                      toaster.success('Roster Uploaded Successfully!');
                    })
                    .finally(function () {
                      $scope.loadingImport = false;
                    });
                }
              };
            },
          ],
        });
      };

      ctrl.downloadCsv = function () {
        const link = new URL('/api/v3/user/student_data/download', window.location.origin);
        link.searchParams.set('by', 'student');
        link.searchParams.set('school_class_id', ctrl.class.school_class_id);

        if (ctrl.end && ctrl.start) {
          link.searchParams.set('start', ctrl.start);
          link.searchParams.set('end', ctrl.end);
          link.searchParams.set('startFormatted', moment.unix(ctrl.start).format('MM/DD/YYYY'));
          link.searchParams.set('endFormatted', moment.unix(ctrl.end).format('MM/DD/YYYY'));
        }

        window.open(link.href);
      };

      if ($stateParams.invite_students) {
        ctrl.showInvite();
      }
    },
  ],
});
